import NetworkService from "./NetworkService";

export default class ConnectAccountService extends NetworkService {
  constructor() {
    super();
    this.endpoints.connectAccounts = "api/connect-accounts";
  }

  /**
   * Lista contas Stripe Connect
   * @param {Object} filters - Filtros para a busca (user_id, etc)
   * @returns {Promise}
   */
  list(filters = {}) {
    return this.get(this.endpoints.connectAccounts, filters);
  }

  /**
   * Prepara dados da conta para exibição
   * @param {Object} account - Conta retornada da API
   * @returns {Object}
   */
  prepareAccount(account) {
    return {
      ...account,
      created_at_formatted: account.created_at
        ? this.$moment(account.created_at).format("DD/MM/YYYY HH:mm")
        : "-",
      updated_at_formatted: account.updated_at
        ? this.$moment(account.updated_at).format("DD/MM/YYYY HH:mm")
        : "-",
    };
  }
}
